<template>
  <div class="myvideo_container">
    <div class="video_box">
      <!-- src=''会以当前页面的地址加载资源，所以 为空时不要设置该属性 -->
      <!-- <video :data-src="src" :id="id" muted="true" :poster="poster" autoplay></video> -->
      <!-- <video :data-src="src" :id="id" muted="true" :poster="myPoster" preload></video> -->
      <video :src="src" :id="id" muted="true" :poster="myPoster" preload></video>
      <div class="mask play" v-if="playShow">
        <img src="@/assets/img/rich/play.png" alt="" @click.stop="play">
      </div>
      <div class="mask loading" v-if="loadingShow">
        <img src="@/assets/img/rich/loading.png" alt="">
        <p class="tips">加载中...</p>
      </div>
      <div class="mask replay" v-if="replayShow" @click.stop="replay">
        <img src="@/assets/img/rich/replay.png" alt="">
        <p class="tips">重播</p>
      </div>
      <div v-if="!$store.state.isU3d" class="volumn" :class="muted ? 'muted' : ''" @click.stop="toogleVolumn"></div>
      <div class="progress_box">
        <div class="bar" :style="{ width: `${playProgress}%` }"></div>
      </div>
      <div class="time" v-if="!$store.state.isU3d">{{ playTime }}</div>
    </div>

    <div class="volumn" @click="toogleVolumn"></div>
    <div class="play"></div>
    <!-- <br>
    <br>
    <button @click.stop="play">开始播放</button>
    <button @click.stop="pause">暂停</button>
    <button @click.stop="muted">静音</button>
    <button @click.stop="volume">打开声音</button>
    <button @click="setrate">设置倍速</button>
    <button @click="setVideoLoad">load</button> -->
    <!-- <button></button> -->
    <!-- <p id="#timePass">{{ playProgress }}</p> -->
  </div>
</template>
      
<script>
export default {
  name: "myVideo",
  props: {
    id: String,
    src: String,
    poster: String,
  },
  data() {
    return {
      playProgress: "",
      playShow: true,
      loadingShow: false,
      replayShow: false,
      myVideo: null,
      // videoSrc: 'https://media.zlongame.com/media/upload/20230313/tdj_2023031301.mp4',
      muted: true,
      duration: 0,
      timer: null,
      playTime: "00:00",
      currentTime: 0,
      value: 0,
      myPoster: this.poster,
    };
  },
  computed: {
  },
  created() {
    let img = new Image()
    img.src = this.poster
    img.onLoad = () => {
    }
    img.onerror = () => {
      this.myPoster = require('@/assets/img/rich/t_cover2.jpg')
    }
  },
  mounted() {
    this.myVideo = document.querySelector("#" + this.id);
    this.myVideo.addEventListener("playing", () => {
      this.replayShow = false
      this.playShow = false
      //播放中
      this.timer = setInterval(() => {
        this.playTime = this.getTime(Math.round(this.myVideo.currentTime));
        this.currentTime = this.myVideo.currentTime;
        this.playProgress = parseInt(
          (this.myVideo.currentTime / this.myVideo.duration) * 100
        );
      }, 1000);
    });
    this.myVideo.addEventListener("ended", () => {
      this.replayShow = true;
      this.playShow = false
      this.loadingShow = false
      this.playProgress = "100";
      clearInterval(this.timer);
      console.log("播放结束");
    });
    let io = new IntersectionObserver(
      (entries) => {
        // console.log(entries, "entries");
        let container = entries[0].target;
        // intersectionRatio：目标元素的可见比例，即intersectionRect占boundingClientRect的比例，完全可见时为1，完全不可见时小于等于0
        if (entries[0].intersectionRatio == 1) {
          this.playShow = true;
          this.replayShow = false;
          if (container.src === "") {
            container.src = container.dataset.src;
            setTimeout(() => {
              this.playShow = true
            }, 100)
          } else {
            this.playShow = true
          }
        } else if ( entries[0].intersectionRatio >= 0.25) {
          if (container.src === "") {
            container.src = container.dataset.src;
          } else {
            if (this.$store.state.isInGame && this.$store.state.isU3d) return
          }
        } else {
          this.playShow = true;
          container.pause();
          clearInterval(this.timer);
        }
      },
      { threshold: [0, 0.25, 0.5, 0.75, 1] },
      { rootMargin: "-200px 0px 100px 0px" }
    );
    io.observe(this.myVideo);

  },
  methods: {
  
    play() {
      const src = this.src
      if (this.$store.state.isInGame && this.$store.state.isU3d) {
      // eslint-disable-next-line no-constant-condition
      // if (3 > 1) {
        var count = 3000;
        var pace = 50;
        let isQa = /^(test|qa)-/.test(location.hostname);
        let pageUrl = 'https://' + (isQa ? 'qa-' : '') + 'www.sugarfungame.com/actv/communityVideo/index.html?id='
        setTimeout(function(){
            try {
                window.gotoUrl(pageUrl + src);
            } catch (err) {
                count = count - pace;
                if (count >= 0) {
                    arguments.callee();
                }
            }
        }, pace);
      } else {
        this.myVideo.play();
        this.playShow = false;

      }
      
    },
    pause() {
      clearInterval(this.timer);
      this.myVideo.pause();
    },
    toogleVolumn() {
      this.muted = !this.muted;
      this.myVideo.muted = this.muted;
      console.log("切换静音");
    },
    replay() {
      this.myVideo.currentTime = 0;
      this.myVideo.play();
      this.replayShow = false;
    },
    // muted() {
    //   this.myVideo.muted = true;
    // },
    volume() {
      this.myVideo.muted = false;
    },
    setrate() {
      this.myVideo.playbackRate = 2;
    },
    getTime(time) {
      // 转换为式分秒
      let h = parseInt((time / 60 / 60) % 24);
      h = h < 10 ? "0" + h : h;
      let m = parseInt((time / 60) % 60);
      m = m < 10 ? "0" + m : m;
      let s = parseInt(time % 60);
      s = s < 10 ? "0" + s : s;
      // 作为返回值返回
      return m + ":" + s;
      //   return [h, m, s]
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  activated() {
    // console.log('active')
    if (this.id === this.$store.state.videoId) {
      this.myVideo.currentTime = this.$store.state.videoProgress;
      this.myVideo.play()
    }
    let img = new Image()
    img.src = this.poster
    img.onLoad = () => {
      console.log('封面图片加载成功')
    }
    img.onerror = () => {
      console.log('封面图片加载失败')
      this.myPoster = require('@/assets/img/rich/t_cover2.jpg')
    }
  },
};
</script>
      
<style lang="scss" scoped>
.myvideo_container {
  .video_box {
    width: 100%;
    height: 3.8rem;
    position: relative;

    // overflow: hidden;
    video {
      height: 3.8rem;
      object-fit: cover;
      border-radius: 6px;
    }

    .mask {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      // background-color: rgba($color: #000, $alpha: 0.5);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      img {
        // position: absolute;
        // left: 0;
        // right: 0;
        // top: 0;
        // bottom: 0;
        // margin: auto;
        width: 0.44rem;
        height: 0.45rem;
        animation: loading 3s linear infinite;
        cursor: pointer;
      }

      &.replay {
        img {
          animation: none;
        }
      }

      &.play {
        img {
          width: 0.84rem;
          height: 0.84rem;
          animation: none;
        }
      }

      .tips {
        margin-top: 0.1rem;
        font-size: 0.2rem;
        text-align: center;
        color: #fff;
      }
    }

    .volumn {
      width: 0.34rem;
      height: 0.24rem;
      background: url(../../assets/img/rich/volumn.png);
      background-size: 100% 100%;
      position: absolute;
      bottom: 0.26rem;
      left: 0.3rem;

      &.muted {
        background-image: url(../../assets/img/rich/muted.png);
      }
    }

    .progress_box {
      width: 100%;
      height: 0.07rem;
      background-color: #b4b4b4;
      position: absolute;
      bottom: 0;

      .bar {
        position: absolute;
        left: 0;
        width: auto;
        height: 100%;
        // background-color: #2c89f1;
      }
    }

    .time {
      width: 0.8rem;
      height: 0.24rem;
      background-color: rgba($color: #000, $alpha: 0.5);
      line-height: 0.24rem;
      text-align: center;
      color: #fff;
      font-size: 0.18rem;
      position: absolute;
      right: 0.3rem;
      bottom: 0.26rem;
    }
  }
}

.gl {
  .myvideo_container {
    .bar {
      background-color: #23323d;
    }
  }
}


.lzgwy {
  .myvideo_container {
    .bar {
      background-color: #2c89f1;
    }
  }
}
@keyframes loading {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>